// ETAB ADMIN FOLDER

export const ETAB_PAYMENT_MEANS_TYPES = {
  DEBIT: {
    code: "sepa_debit",
    label: "CORE.MODELS.PAYMENT_MEANS.@DEBIT",
  },
  BANK_TRANSFER: {
    code: "bank_transfer",
    label: "CORE.MODELS.PAYMENT_MEANS.@BANK_TRANSFER",
  },
  NONE: {
    code: "none",
    label: "CORE.MODELS.PAYMENT_MEANS.@NONE",
  },
};
